<template>
  <div>
    <Dialog
      :visible.sync="expiryDateDialog1"
      :style="{ width: '600px', height: '600px', overflowY: 'auto' }"
      header="Expiry Date Box"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">Expiry Date</label>
          <Calendar
            id="icon1"
            v-model="expiryDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
          />
          <small class="p-invalid" v-if="submitted && !expiryDate"
            >Expiry Date is required.</small
          >
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-4 p-md-3 p-sm-3"></div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              style="width: 100px;"
              @click="$emit('close')"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              style="width: 100px;"
              @click="save"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    expiryDateDialog: {
      type: Boolean,
      required: true
    },
    reload: {
      type: Number,
      required: false
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    expiryDate: "",
    submitted: false
  }),
  computed: {
    expiryDateDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.expiryDateDialog;
      }
    }
  },
  watch: {
    reload(val) {
      this.expiryDate = "";
      this.submitted = false;
    }
  },
  methods: {
    save() {
      this.submitted = true;

      if (this.expiryDate && this.expiryDate.getTime() > new Date().getTime()) {
        this.$emit("save", this.expiryDate);
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Warning",
          detail: "Expiry date must be greater than todays date.",
          life: 5000
        });
      }
    }
  }
};
</script>

<style></style>
